// extracted by mini-css-extract-plugin
module.exports = {"title":"TechInfo_title__1GUMy","line":"TechInfo_line__86cAw","download":"TechInfo_download__3JLcC","downloadDisabled":"TechInfo_downloadDisabled__NaZsZ"};